import styled from '@emotion/styled';
import { css } from '@emotion/react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItem from '@mui/material/ListItem';
import Popper from '@mui/material/Popper';
import { PaperStyled as PaperStyledFieldDropdown } from '../field-dropdown/field-dropdown.styles';
import { useDiscoverTheme } from '../../common/emotion';
import { CheckIconSmall } from '../../icons';

export const ListButtonStyled = styled(ListItemButton)(
  () => css`
    font-size: 0.75rem;
    font-weight: 300;
    padding: 4px 8px 4px 14px;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    position: relative;

    &:hover {
      background-color: transparent;
    }

    .MuiSvgIcon-root {
      max-width: 20px;
    }
  `,
);

export const PaperStyled = styled(PaperStyledFieldDropdown)(() => {
  const { isDashletMode } = useDiscoverTheme();
  return css`
    border: none;

    ${isDashletMode &&
    css`
      min-height: 150px;
    `}
  `;
});

export const CheckIconStyled = styled(CheckIconSmall)`
  position: absolute;
  left: -10px;
`;

export const MenuItemSpacedForCheck = styled(ListItem)`
  ${ListButtonStyled} {
    padding-left: 8px;
  }
  padding: 0 0 0 18px;
`;

export const PopperStyled = styled(Popper)(() => {
  const {
    colors: { MediumBorder },
  } = useDiscoverTheme();
  return css`
    border: 1px solid ${MediumBorder};
    &#time-hierarchy-submenu {
      ${MenuItemSpacedForCheck} {
        padding: 0;
      }
    }
  `;
});
